import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import habilidades from './modules/habilidades'
import expertises from './modules/expertises'
import permissoes from './modules/permissoes'
import usuario from './modules/usuario'
import classes from './modules/classes'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    habilidades,
    expertises,
    permissoes,
    usuario,
    classes
  }
})